import React from 'react'

export default (props) => {

  const { children, entityKey, contentState } = props
  const { href, target } = contentState.getEntity(entityKey).getData()

  return (
    <span className='bf-link-wrap'>
      <a onClick={(event) => viewLink(event, href)} className='bf-link' href={href} target={target}>{children}</a>
    </span>
  )

}

const viewLink = (event, link) => {
  // å½æä¸Ctrl/commandé®æ¶ï¼ç¹å»æå¼é¾æ¥æå­ä¸­çurl
  if (event.getModifierState('Control') 
      || event.getModifierState('Meta')) {
    const tempLink = document.createElement('a')
    tempLink.href = link
    tempLink.target = event.currentTarget.target
    tempLink.click()
  }
}